import { useContext } from 'react';
import { AuthContext } from '../context/auth.context';
import type { Organization } from '../types';

/**
 * Read the current organization from AuthContext. Returns null gracefully
 * when used outside an AuthProvider (admin portal). Tenant identity is
 * set once at app boot and is read-only for the session — switching orgs
 * triggers a full reload, not an in-place state update.
 */
export function useCurrentOrg(): { currentOrg: Organization | null; loading: boolean } {
  const context = useContext(AuthContext);
  if (!context) {
    return { currentOrg: null, loading: false };
  }
  return { currentOrg: context.currentOrg, loading: context.loading };
}
